module.exports = __webpack_public_path__ + "img/ringsets.f421b96.webp";